import React, { useEffect } from 'react'
import { Container, Row, CloseButton } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Navigation, Scrollbar } from 'swiper/modules';
import data2 from '../incense';
import data3 from '../balm';
import { useState } from 'react';
import { Product } from '../components/Product';
import axios from 'axios';
import data9 from '../candle'
import data5 from '../sample'
import { useNavigate } from 'react-router-dom';
import Topslider from '../components/Topslider';



const Home = (props) => {
    let slideTitle = ['Showery Body', 'Perfume Balm', 'Toilet Fragrance', 'Perfume Hand', 'Perfume Soap']
    const { soap, setSoap, count, setCount } = props;
    let [incense, setIncense] = useState(data2);
    let [balm] = useState(data3);
    let [candle, setCandle] = useState(data9)
    console.log(incense);
    let [two, setTwo] = useState(1);
    let [sam, setSam] = useState(1)
    let [cn, setCn] = useState(1);
    let [sample, setSample] = useState(data5)
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);



    return (
        <>
           
            <button className='close' onClick={() => { setVisible(!visible); }}>{visible ? "" : "X"}</button>
            {visible || <Topslider />}

            <Swiper
                scrollbar={{
                    hide: true,
                }}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: true,
                }} loop={true} speed={2000}
                modules={[Scrollbar, Autoplay]}
                className="twoslide"
            >

                {
                    slideTitle.map((v, i) =>
                        <SwiperSlide className={'two a' + i}>
                            <div className='a-1'>
                                <p><a href="#">{v}</a></p>
                            </div>
                        </SwiperSlide>
                    )
                }

            </Swiper>

            <div className="text">
                <div className='img'></div>
            </div>

            <div className='object'>
                <h2>Perfume Soap</h2>
                <span>논 밭을 일구어 수확한 퍼퓸 비누 4종을 소개합니다. <br /> 작물을 수확할 때의 기쁨을 형상화한 퍼퓸 비누. 농부의 땀으로 결실을 맺은 4가지 열매의 형상을 띈 약산성 제형의 퍼퓸 비누는 <br /> 탬버린즈만의 다채로운 향과 함께 시각적, 촉각적 감각을 일깨우며 각기 다른 즐거움을 전합니다.</span>
                <Container>
                    <Row>

                        {soap.map((v, i) => {
                            return (<Product soap={soap[i]} key={i} />)
                        })}
                    </Row>
                    <button onClick={() => {
                        if (count === 1) {
                            axios.get('https://se0304.github.io/tamburins_data/data2.json').then((result) => {

                                let copy = [...soap, ...result.data];
                                setSoap(copy);
                                console.log(soap);
                                setCount(2);
                            })
                        } else if (count === 2) {
                            axios.get('https://se0304.github.io/tamburins_data/data3.json').then((result) => {
                                let copy = [...soap, ...result.data];
                                setSoap(copy);
                                setCount(3)
                            })
                        } else {
                            alert("더이상 상품이 없습니다.");
                        }
                    }} className='soap'>More</button>
                </Container>


            </div>

            <div className='object'>
                <h2>Scent Object</h2>
                <span><b>‘Contemporary handicraft’ 손으로 만드는 아름다움</b> <br /> <br /> 탬버린즈의 향수의 향을 공간에서도 편안하게 즐길 수 있는 ‘향 오브젝트’ 캔들 컬렉션을 공개합니다. 탬버린즈의 세 번째 향 오브젝트 <br /> 라인 ‘블루밍 캔들’은 손으로 만드는 아름다움이 돋보이는 수작업 캔들입니다. 공예적 특성이 돋보이는 리미티드 캔들은 일상적인 <br /> 공간이 비일상으로 전환되는 특별한 감정을 선사합니다. 나만의 공간에 아름다움을 더하는 인테리어 오브젝트로 활용, 소중한 <br /> 사람들과의 잊지 못할 순간을 기록하기 위한 무드등으로 사용해 보세요.</span>
                <Container>
                    <Row>
                        {incense.map((v, i) => {
                            return (<Product incense={incense[i]} key={i} />)
                        })}
                    </Row>
                    <button onClick={() => {
                        if (two === 1) {
                            axios.get('https://se0304.github.io/tamburins_data/data4.json').then((result) => {
                                let copy2 = [...incense, ...result.data];
                                setIncense(copy2);
                                setTwo(2);
                            })
                        } else {
                            alert("더이상 상품이 없습니다.")
                        }
                    }} className='soap'>More</button>
                </Container>
            </div>

            <div className='object'>
                <h2>Perfume Balm</h2>
                <span>감각적으로 향을 즐길 수 있는 새로운 형태의 퍼퓸밤. 핸디한 사이즈의 퍼퓸 밤과 함께 어디서든 자유롭게 향을 경험하고 스스로를 <br /> 표현해보세요. 부드러운 텍스처로 맥박이 뛰는 손목, 귀밑 등에 부드럽게 발라주면 체온에 의해 은은하게 퍼지는 향을 느끼실 수 <br /> 있습니다. 아이코닉한 퍼퓸 밤 디자인은 탬버린즈 퍼퓸의 일부가 미러링된 형태로 확장된 퍼퓸의 페르소나를 표현합니다.</span>
                <Container>
                    <Row>
                        {balm.map((v, i) => {
                            return (<Product balm={balm[i]} key={i} />)
                        })}
                    </Row>
                    <button onClick={() => {
                        alert("더이상 상품이 없습니다.")
                    }} className='soap'>More</button>
                </Container>
            </div>

            <div className='object'>
                <h2>Olfactive Candle</h2>
                <span>하나씩 정성을 들여 수작업으로 제작되는 '올팩티브 아카이브 캔들'은 가장 원초적인 자연에 대한 접근에서 비롯되었습니다. <br /> 콘크리트로 이루어진 캔들 표면의 자연스러운 텍스쳐는 마치 얼어붙은 대지 위에 펼쳐진 설경과 빙산의 일부분을 떠올리게 합니다. <br /> 기억의 향기를 담은 따듯한 불씨가 당신의 공간을 안락함으로 채워줍니다.</span>
                <Container>
                    <Row>

                        {candle.map((v, i) => {
                            return (<Product candle={candle[i]} key={i} />)
                        })}
                    </Row>
                    <button onClick={() => {
                        if (cn === 1) {
                            axios.get('https://se0304.github.io/tamburins_data/data5.json').then((result) => {

                                let copy = [...candle, ...result.data];
                                setCandle(copy);
                                // console.log(soap);
                                setCn(2);
                            })
                        } else {
                            alert("더이상 상품이 없습니다.");
                        }
                    }} className='soap'>More</button>
                </Container>


            </div>

            <div className='object'>
                <h2>Sample Kits</h2>
                <Container>
                    <Row>

                        {sample.map((v, i) => {
                            return (<Product sample={sample[i]} key={i} />)
                        })}
                    </Row>
                    <button onClick={() => {
                        if (sam === 1) {
                            axios.get('https://se0304.github.io/tamburins_data/data6.json').then((result) => {

                                let copy = [...sample, ...result.data];
                                setSample(copy);
                                // console.log(soap);
                                setSam(2);
                            })
                        } else if (sam === 2) {
                            axios.get('https://se0304.github.io/tamburins_data/data7.json').then((result) => {
                                let copy = [...sample, ...result.data];
                                setSample(copy);
                                setSam(3)
                            })
                        } else {
                            alert("더이상 상품이 없습니다.");
                        }
                    }} className='soap'>More</button>
                </Container>


            </div>

            <div className='banner'>
            </div>
            

        </>


    )
}

export default Home